/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const peopleIncidentEnumsTypeOfIncidentOptionEnum = {
    FallAndSlip: 'FallAndSlip',
    ElectricalContactArcFlash: 'ElectricalContactArcFlash',
    VehicleMobileEquipmentIncident: 'VehicleMobileEquipmentIncident',
    Ergonomics: 'Ergonomics',
    Viruses: 'Viruses',
    MicroOrganismAndOrToxins: 'MicroOrganismAndOrToxins',
    Other: 'Other',
    ChemicalRelease: 'ChemicalRelease',
    MachineryToolsEquipment: 'MachineryToolsEquipment',
    ManualHandling: 'ManualHandling',
} as const;

export type PeopleIncidentEnumsTypeOfIncidentOptionEnumKey =
    (typeof peopleIncidentEnumsTypeOfIncidentOptionEnum)[keyof typeof peopleIncidentEnumsTypeOfIncidentOptionEnum];

export type PeopleIncidentEnumsTypeOfIncidentOption = PeopleIncidentEnumsTypeOfIncidentOptionEnumKey;
